module.exports = __webpack_public_path__ + "img/istcoll.9193395.png";